// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SuspenseLoader_wrapper__8Qmrx"};